import { format, getTime, formatDistanceToNow } from 'date-fns';
import { ko } from 'date-fns/locale'

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy p');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function fKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy-MM-dd HH:mm:ss', { timezone: 'Asia/Seoul' });
  }
}

export function fKrKSTFile(date) {
  if(date) {
    return format(new Date(date), 'yyyy.MM.dd (EE) HH:mm', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrKSTShort(date) {
  if(date) {
    return format(new Date(date), 'MM.dd (EE) HH:mm', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrKSTFull(date) {
  if(date) {
    return format(new Date(date), 'yyyy년 M월 d일 EEEE bb h시 m분', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrKST(date) {
  if(date) {
    return format(new Date(date), 'M월 d일 EEEE bb h시 m분', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrSendKST(date) {
  if(date) {
    return format(new Date(date), 'M월 d일 EEEE bb h시', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrMdEKST(date) {
  if(date) {
    return format(new Date(date), 'M월 d일 EEEE', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrDateKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy년 M월 d일', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrTimeKST(date) {
  if(date) {
    return format(new Date(date), 'bb h시 m분', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrNegoTimeKST(date) {
  if(date) {
    return format(new Date(date), 'M월 d일 bb h시', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fDotDateKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy.MM.dd', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fDashDateKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy-MM-dd', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fYYYYMMDD(date) {
  if (date) {
    return format(date, 'yyyy-MM-dd');
  }
  return ''
}

export function fKrDateAbsoulte(date) {
  if(date) {
    const [y, m, d] = date.split('-');
    return `${parseInt(y)}년 ${parseInt(m)}월 ${parseInt(d)}일`;
  }
}

export function fKrDateAbsoulteM(date) {
  if(date) {
    const [y, m, d] = date.split('-');
    return `${parseInt(m)}월`;
  }
}

export function fKrDateAbsoulteMD(date) {
  if(date) {
    const [y, m, d] = date.split('-');
    return `${parseInt(m)}월 ${parseInt(d)}일`;
  }
}

export function fKSTDateAbsoluteDuration(kstDate) {
  if(kstDate) {
    return kstDate.substring(0, 10).replaceAll("-", ".");
  }
}

export function fKrDateDayKST(date) {
  if (date) {
    return format(new Date(date), 'yyyy년 M월 d일 EEEE', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrCoffeeChatTimeKST(date) {
  if (date) {
    return format(new Date(date), 'yyyy년 M월 d일 a hh:mm', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrMDEEEEKST(date) {
  if(date) {
    return format(new Date(date), 'EEEE(M월 d일)', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrTrackingTimeYMDKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy.MM.dd', { timezone: 'Asia/Seoul' });
  }
}

export function fKrTrackingTimeKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy.MM.dd hh:mm a', { timezone: 'Asia/Seoul' });
  }
}

export function fKrTrackingTimeShortKST(date) {
  if(date) {
    return format(new Date(date), 'hh:mm a', { timezone: 'Asia/Seoul' });
  }
}

export function fKrHourMinute(date) {
  if(date) {
    return format(new Date(date), 'p', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrCandidateCardMeetingTimeKST(date) {
  if(date) {
    return format(new Date(date), 'yyyy.MM.dd EE a h:mm', { locale: ko, timezone: 'Asia/Seoul' });
  }
}

export function fKrMeetingTodoTimeKST(date) {
  if(date) {
    return format(new Date(date), 'M월 d일 (EE) a h시', { locale: ko, timezone: 'Asia/Seoul' });
  }
}
